'use client';

import { useField } from "../internals/hooks/useField/index.mjs";
import { useDateManager } from "../managers/index.mjs";
export const useDateField = props => {
  const manager = useDateManager();
  return useField({
    manager,
    props
  });
};